module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_2-fbe24472875614df13277914ab78fea5.jpg";